import { baseShadowStyle } from '@shared/style/base-shadow';
import { COLORS } from '@shared/config/colors/colors';
import { Badge } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    width: 100%;
    gap: 24px;
    padding: 20px;
    border-radius: 20px;
    background-color: ${COLORS.neutral_00};
    flex-direction: column;
    ${baseShadowStyle}
`;

export const Header = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Content = styled('div')`
    position: relative;
    display: flex;
    gap: 20px;

    > * {
        width: 100%;
    }
`;

export const TabLabel = styled('div')`
    display: flex;
    align-items: center;
    gap: 4px;
`;
export const StyledBadge = styled(Badge)`
    position: relative !important;
    transform: none !important;
    > div {
        position: relative !important;
        transform: none !important;
    }
`;

export const SliderControls = styled('div')`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const SlideContent = styled('div')`
    height: 100%;

    > * {
        height: 100%;
    }
`;
